import Vue from 'vue'
import Navbar from './Navbar.vue'
import CloseHeaderBasic from './CloseHeaderBasic.vue'

Vue.component('navbar-layout', Navbar)
Vue.component('close-header-basic-layout', CloseHeaderBasic)
